import { IndicatorType } from '../constants/common'
import math from '../helpers/math'
import { drawInVisibleArea } from '../utils/draw_in_visible_area'
import Indicator from './indicator'

class OBV extends Indicator {
  static type = IndicatorType.Obv
  static label = 'On-Balance Volume'

  obv: number[] = []

  compute() {
    if (this.isComputeNecessary()) {
      this.obv = [0]

      for (let i = 1; i < this.data.volume.length; i++) {
        let currentObv = this.obv[i - 1]
        if (this.data.close[i] > this.data.close[i - 1]) {
          currentObv += this.data.volume[i]
        } else if (this.data.close[i] < this.data.close[i - 1]) {
          currentObv -= this.data.volume[i]
        }

        this.obv[i] = currentObv
      }

      this.lastValue = this.obv.last() ?? null
    }
    const { min, max } = this.obv.length > 0 ? this.computeVisibleMinMax(this.obv) : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    context.set('strokeStyle', this.getChartLayoutSettings().IndicatorSettings.general.Colors.line)
    context.translate(0.5, 0.5)
    context.beginPath()
    drawInVisibleArea({
      quote: this.data,
      scale: this.model.scale,
      leftOffset: this.leftOffset,
      width: this.width,
      drawBarCallback: (i: number, x: number) => {
        context.lineTo(x, Math.round(this.fy(this.obv[i])))
      },
    })
    context.stroke()
    context.translate(-0.5, -0.5)
  }

  formatAxis(value: number) {
    return math.formatBigNumber(value, 2)
  }

  getModalConfig() {
    return {
      title: this.label,
      inputs: [],
      inputsErrorMessages: {},
    }
  }

  toString() {
    return 'OBV'
  }
}

export default OBV
